import React from "react";
import PropTypes from "prop-types";
import ModalContainer from "../../components/common/ModalContainer";
import { LoadingOverlay } from "./message/LoadSpinner";
import { ConfirmationModal } from "./message/ConfirmationModal";
import MessageContainer from "./message/MobxMessageContainer";
import SiteFooter from "shared/components/navigation/SiteFooter";
import SessionExpiringModalView from "../../components/session/SessionExpiringModalView";
import Propulator from "higher-order/Propulator";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { URLS } from "util/constants";
import environmentUtilities from "util/environmentUtilities";
import MouseflowIdentifier from "./mouseflow/MouseflowIdentifier";
import Disclaimers from "member/components/shared/Disclaimers";

@observer
class MobxPageContent extends React.Component {
    @observable hasError;

    static propTypes = {
        header: PropTypes.object,
        navigation: PropTypes.object,
        footer: PropTypes.object,
        className: PropTypes.string,
        disclaimers: PropTypes.string
    };

    componentDidMount() {
        this.props.dispatcher.emit("LOAD_SESSION_DATA");
    }

    componentDidCatch(error, info) {
        this.hasError = true;
    }

    _renderErrorMessage() {
        if (environmentUtilities.isProdIntra(this.props.session)) {
            return (
                <h1 className="js-error">Oops, there was an error!</h1>
            );
        }

        const isMemberPortal = this.props.session?.siteFooterModel?.isMemberPortal;
        const isLoggedIn = this.props.session?.isLoggedIn;
        // eslint-disable-next-line no-nested-ternary
        const contactUrl = !isLoggedIn
            ? URLS.MARKETING.CONTACT
            : isMemberPortal
                ? URLS.MEMBER.CONTACT
                : URLS.EMPLOYER.CONTACT;

        return (
            <h1 className="js-error">Oops, there was an error! Please <a href={contactUrl}>contact</a> customer service.</h1>
        );
    }

    render() {
        return (
            <div id="view" className={this.props.className}>
                <div className="flash-page-wrapper">
                    <MessageContainer type="flash" />
                </div>
                {this.props.header ? this.props.header : null}
                <div className="site-content">
                    {this.props.session?.isLoggedIn && <MouseflowIdentifier user={this.props.session?.user ?? {}} />}
                    {this.props.navigation}
                    <main className="content">
                        {this.hasError
                            ? this._renderErrorMessage()
                            : this.props.children}
                    </main>
                </div>
                {this.props.disclaimers && <Disclaimers disclaimers={this.props.disclaimers} />}
                {this.props.footer ?? <SiteFooter />}
                <SessionExpiringModalView />
                <ModalContainer />
                <LoadingOverlay />
                <ConfirmationModal />
            </div>
        );
    }
}

export default Propulator(MobxPageContent, {
    sessionStore: ["session"],
    contentStore: ["content"]
});
